/**
 * "Trùng với dòng nào" — cho màn Nhập hoá đơn bằng AI.
 *
 * Backend đánh dấu `matchStatus: 'duplicate'` khi hai dòng trong CÙNG đợt
 * cùng ký hiệu/số/MST (`ocrInvoiceId` khớp), nhưng trước giờ màn hình chỉ
 * hiện một chữ "Trùng" — không nói trùng với dòng nào, nên người duyệt không
 * có cách kiểm tra đúng/sai (yêu cầu kế toán, 13/10/2026: "cái hoá đơn đâu
 * có ghi gì đâu mà nó báo trùng"). Việc này THUẦN ở client vì danh sách dòng
 * của cả đợt đã có sẵn trong bộ nhớ, không cần hỏi lại server.
 */

/** Các dòng KHÁC trong `items` cùng `ocrInvoiceId` với `item`. */
export function timDongTrungKhac(items, item) {
  if (!item?.ocrInvoiceId) return [];
  return (items || []).filter(
    (x) => x._id !== item._id && x.ocrInvoiceId === item.ocrInvoiceId,
  );
}

/** Nhãn ngắn gọn để hiện một dòng: tên file, kèm số trang nếu file có nhiều trang. */
export function nhanDong(item) {
  const trang = item?.pageCount > 1 ? ` (trang ${(item.pageIndex ?? 0) + 1})` : '';
  return `${item?.originalName || '—'}${trang}`;
}
